export const IFRAME_DARK_MODE_MESSAGE = "FLUIDSDATA_DARK_MODE";

export function getIframeOrigin(envUrl) {
  if (!envUrl) return null;
  try {
    return new URL(envUrl).origin;
  } catch {
    return null;
  }
}

export function notifyIframeDarkMode(iframeEl, isDarkMode, envUrl) {
  const origin = getIframeOrigin(envUrl);
  if (!iframeEl?.contentWindow || !origin) return;
  iframeEl.contentWindow.postMessage(
    { type: IFRAME_DARK_MODE_MESSAGE, darkMode: !!isDarkMode },
    origin
  );
}
